import React from 'react'

const SelectInput = React.forwardRef((props, ref) => (
  <select
    className='select-input'
    {...props}
    ref={ref}
    onChange={props.onChange} 
  >
    {
      props.options.map((o, i) => <option key={i} value={o[0]}>{o[1]}</option>)
    }
  </select>
))

export default SelectInput
